angular.module('app.services').service('preloaders', ($rootScope, $timeout, utils) => {
    $rootScope.content_preloader_show = (style, container) => {
        const $body = $('body');
        $body.addClass('content_preloader');

        if (!$body.find('.content-preloader').length) {
            const image_density = utils.isHighDensity() ? '@2x' : '';

            const preloader_content =
                typeof style !== 'undefined' && style == 'regular'
                    ? `<img src="/img/spinners/spinner${image_density}.gif" alt="" width="32" height="32">`
                    : '<div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="32" width="32" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="8"/></svg></div>';

            const thisContainer = typeof container !== 'undefined' ? container : $body;

            thisContainer.append(`<div class="content-preloader">${preloader_content}</div>`);
            $timeout(() => {
                $('.content-preloader').addClass('preloader-active');
            });
        }
    };

    $rootScope.content_preloader_hide = () => {
        const $body = $('body');
        $body.removeClass('content_preloader');

        if ($body.find('.content-preloader').length) {
            // hide preloader
            $('.content-preloader').removeClass('preloader-active');
            // remove preloader
            $timeout(() => {
                $('.content-preloader').remove();
            }, 500);
        }
    };
});
